import { useOrgResolvedFlag } from './useOrgResolvedFlag';

/** PostHog flag key gating the intelligence conflict-notifications feature (prefs UI + send job). */
export const CONFLICT_NOTIFICATIONS_FLAG = 'conflict-notifications-enabled';

/** Conflict-notifications flag + per-org resolution, for the nav entry and the page redirect gate. */
export function useConflictNotificationsFlag(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(CONFLICT_NOTIFICATIONS_FLAG);
}

// resolved OFF must redirect, not hold on the loader — flag-off users have no page to wait for.
export function resolveNotificationsGate(resolved: boolean, enabled: boolean): 'loading' | 'redirect' | 'show' {
  if (!resolved) return 'loading';
  return enabled ? 'show' : 'redirect';
}

/** PostHog flag key gating the weekly conflicts-changed digest (prefs toggle + send job). */
export const CONFLICTS_CHANGE_NOTIFICATIONS_FLAG = 'conflicts-change-notifications-enabled';

/** Conflicts-changed digest flag + per-org resolution, for the notifications-page toggle. */
export function useConflictsChangeNotificationsFlag(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(CONFLICTS_CHANGE_NOTIFICATIONS_FLAG);
}
